import { FC, ReactNode } from 'react'
import {
  VenuesCollectionCardList,
  VenuesCollectionCardListType,
} from './CardList'
import {
  VenueCollectionCollectionType,
  VenuesCollectionCollection,
} from './Collection'
import {
  VenuesCollectionCardHeader,
  VenuesCollectionCardHeaderType,
} from './Header'

const VenuesCollection: FC &
  VenuesCollectionCardListType &
  VenuesCollectionCardHeaderType &
  VenueCollectionCollectionType = (): ReactNode => <></>

VenuesCollection.Collection = VenuesCollectionCollection
VenuesCollection.Card = VenuesCollectionCardList
VenuesCollection.Header = VenuesCollectionCardHeader

export default VenuesCollection
